import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { ProctoringService } from '../services/proctoring.service';
import { QuestionserviceService } from '../services/questionservice.service';
import { LanguageService } from '../services/language.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-questionlist',
  templateUrl: './questionlist.component.html',
  styleUrls: ['./questionlist.component.css']
})
export class QuestionlistComponent implements OnInit {
  @Input() scheduleid: any;
  @Input() examid: any;
  @Input() examData: any;
  @Output() questionClicked: EventEmitter<number> = new EventEmitter<number>();
  @Output() backClicked: EventEmitter<void> = new EventEmitter<void>();

  groupedQuestionsArray: any[] = [];
  loading: boolean = false;
  onblurfunction;
  onfocusfunction;
  countdown: any;
  lossactionmsg: string = "";
  losscount: number = 0;
  focuslosswarningmessage: string = "";
  lostfocus: boolean = false;
  constructor(public toastr: ToastrService, public activaterouter: ActivatedRoute, public router: Router, public examservice: ExamService, public cbtservice: CbtserviceService,
    private proctorservice: ProctoringService, public questionservice: QuestionserviceService, private languageService: LanguageService, private loadingService: LoadingService) { }

  get language() {
    return this.languageService.language;
  }
  async ngOnInit() {
    try {
      this.loading = true;
      this.loadingService.show();
      if (!this.examData || !this.examData.examid) {
        this.goBack();
      }

      let savedQuestion = await this.questionservice.getAllQuestionWithHtmlFromStorage(this.scheduleid, this.examData.liteMode, this.examData.useCaptcha, this.examid);

      //add answered questions.
      for (let i = 0; i < savedQuestion.questions.length; i++) {
        let question = savedQuestion.questions[i];
        let answered;
        const answerEntry = this.examData.answerData
          ?.find(c => c.questionno === question.examQuestion.questionno);
        if (answerEntry) {
          answered = answerEntry.answered;
        }
        savedQuestion.questions[i].examQuestion.answered = answered;
      }

      const groupedQuestions = savedQuestion.questions.reduce((acc, curr) => {
        const category = curr.examQuestion.category || '';
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(curr);
        return acc;
      }, {} as Record<string, any[]>);
      // Convert to an array of { category, questionList }
      this.groupedQuestionsArray = Object.entries(groupedQuestions).map(([category, questionList]) => ({
        category,
        questionList
      }));

      if (this.examData.checkfocusloss && !this.onblurfunction/* && admintestlogin != "True"*/) {
        this.onblurfunction = this.onBlur.bind(this);//have to do it this way because if i just set the event listener to this.setTileSize, the "this" becomes window
        this.onfocusfunction = this.onFocus.bind(this);
        window.addEventListener('focus', this.onfocusfunction);
        window.addEventListener('blur', this.onblurfunction);
      }
    } catch (error) {
      this.cbtservice.showHttpError(error);
    } finally {
      this.loading = false
      this.loadingService.hide();
    }
  }
  ngOnDestroy(): void {
    if (this.onblurfunction) {
      window.removeEventListener('focus', this.onfocusfunction);
      window.removeEventListener('blur', this.onblurfunction);
    }
  }
  goBack() {
    this.backClicked.emit();
  }
  onFocus() {
    clearTimeout(this.countdown);
    console.log('OnPageVisibilityChange => visible');
    if (this.lostfocus && this.focuslosswarningmessage != '') {
      this.toastr.warning(this.focuslosswarningmessage);
    }
  };
  onBlur() {
    if (this.examData.checkfocusloss && !this.proctorservice.chatopened) {
      let audio = new Audio();
      audio.src = "/assets/beep.mp3";
      audio.loop = false;
      audio.load();
      audio.play();
      console.log("audio played");
      const mythis = this;
      this.countdown = setTimeout(() => {
        //debugger;
        // if (!mythis.proctorservice.chatopened) {
        //   this.setres();
        // }
        // if ((this.examination.nooffocusloss - this.losscount) === 1) {
        //   audio.play();
        //   console.log("audio played")
        // }
      }, 1000 * this.examData.durationofloss);
    }
  }

  gotoquestion(questionno) {
    this.questionClicked.emit(questionno);
  }
}
